import React, { memo, useEffect, useMemo } from 'react';
import ProfitInvest from './ProfitInves.js';
import useAuth from '../../../hooks/useAuth.js';
import UseAccount from '../../../hooks/useAccount';
import { useAppSelector } from '../../../redux/app';

const AccountInfo = memo(() => {
  const { metatrader, activeAccount } = useAuth();
  const tradeEvent = useAppSelector((state) => state?.tradeEvent?.event);
  const { reFetch } = UseAccount();

  useEffect(() => {
    if (tradeEvent === 'BALANCE_UPDATED' || tradeEvent === 'CREDIT_UPDATED') {
      reFetch();
    }
  }, [tradeEvent]);

  const metaAccount = useMemo(() => {
    return metatrader.reduce((a, b) => {
      return {
        ...a,
        [b.id]: b
      };
    }, {});
  }, [metatrader]);

  if (metaAccount) {
    return (
      <div className="section-profile">
        <div className="relative">
          <ProfitInvest
            isDemo={metaAccount[activeAccount]?.type === 'demo'}
            currency={metaAccount[activeAccount]?.currency}
          />
        </div>
      </div>
    );
  }
  return <div />;
});

AccountInfo.displayName = 'AccountInfo';

export default AccountInfo;
